import React from 'react';
import { Favorite } from '@/components/Favorite';
import { BlockButton } from '@/components/BlockButton';

interface ClassifiedCardProps {
  classified: any;
  signedIn?: boolean;
  favorited?: boolean;
  blocked?: boolean;
  blockCallback?: () => void;
  showTypeBadge?: boolean;
}

export function ClassifiedCard({
  classified,
  signedIn,
  favorited = false,
  blocked = false,
  blockCallback,
  showTypeBadge = false,
}: ClassifiedCardProps) {
  const carouselId = 'classified-carousel' + classified.id.toString();
  //const myCarousel = document.querySelector('#'+carouselId);
  //const carousel = new bootstrap.Carousel(myCarousel)

  return (
    <div className="card h-100 postable-card">
      {showTypeBadge && (
        <div className="housing-badges">
          <span className="housing-type-badge badge rounded-pill bg-warning text-dark">Classified</span>
        </div>
      )}
      {typeof signedIn === 'boolean' && (
        <>
          <Favorite
            signedIn={signedIn}
            favoritableType="Classified"
            favoritableId={classified.id}
            favorited={favorited}
          />
          <BlockButton
            signedIn={signedIn}
            blockableType="Classified"
            blockableId={classified.id}
            blocked={blocked}
            noun="classified ad"
            blockCallback={blockCallback}
          />
        </>
      )}
      <div
        className="carousel slide"
        data-bs-ride="carousel"
        style={{ height: '200px', overflow: 'hidden' }}
        id={carouselId}
      >
        <div className="carousel-inner bg-dark card-img-top" style={{ height: '200px' }}>
          {classified.images.map((image: string, index: number) => (
            <div className={'carousel-item h-100 ' + (index === 0 ? 'active' : '')} key={image}>
              <a href={classified.route_path} target="_blank" rel="noreferrer" className="d-block h-100">
                <img
                  src={image}
                  className="d-block w-100 h-100"
                  style={{ objectFit: 'cover' }}
                  alt={classified.title}
                />
              </a>
            </div>
          ))}
          {false && classified.images.length > 1 && (
            <button className="carousel-control-prev" type="button" data-bs-slide="prev" data-bs-target={carouselId}>
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="sr-only">Previous</span>
            </button>
          )}
          {false && classified.images.length > 1 && (
            <button className="carousel-control-next" type="button" data-bs-slide="next" data-bs-target={carouselId}>
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="sr-only">Next</span>
            </button>
          )}
        </div>
      </div>
      <div className="card-body">
        <div className="card-title">
          <a href={classified.route_path} target="_blank" rel="noreferrer">
            {classified.title}
          </a>
        </div>
        <div className="mb-2">
          <span>
            Price: ${Number(classified.price).toLocaleString('en-US')}
            <br />
          </span>
        </div>
      </div>
    </div>
  );
}
